var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "opt-group" },
    [
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.record.status == 0 || _vm.record.status == 3,
              expression: "record.status==0 || record.status==3",
            },
          ],
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.handleEdit()
            },
          },
        },
        [
          _vm._v(
            _vm._s(_vm.$t("userCenter.billConsigneeApplication.editButton")) +
              "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }